import { css } from 'lit';

const IxFileChipStyles = css`
  .file-chip {
    align-items: center;
    background: #f5f7ff;
    cursor: pointer;
    display: flex;
    flex: auto;
    padding: 4px 8px;
    height: 40px;
  }

  .file-chip span {
    margin-right: 10px;

    font-size: var(--ix-file-chip-font-size, var(--text-small-size, 1rem));
    line-height: var(
      --ix-file-chip-line-height,
      var(--text-small-line-height, 1.3rem)
    );
    letter-spacing: var(
      --ix-file-chip-letter-spacing,
      var(--text-small-letter-spacing, 0.15px)
    );
    color: var(--ix-file-chip-color, var(--clr-on-surface, 'inherit'));
  }

  .delete-icon {
    color: var(--md-sys-color-error);
  }
`;

export default IxFileChipStyles;
